import theme from '@theme'
import styled from 'styled-components'

const H1 = styled.h1`
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 500;
  color: ${theme.breadcrumb.focusColor};

  .sub-title {
    color: ${theme.breadcrumb.color};
  }
`

export default H1
